import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { isOurApiUrl } from '../utils/vanity-url.util';
import { LoggerService } from './logger.service';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private readonly logger: LoggerService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const request = this.isApiRequest(req.url)
      ? req.clone({
          headers: req.headers.set('X-Correlation-Id', this.logger.getCorrelationId()),
        })
      : req;

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && !this.isFrontendLogRequest(req.url)) {
          const context = {
            status: error.status,
            statusText: error.statusText,
            method: req.method,
            url: req.urlWithParams,
          };

          if (error.status >= 500 || error.status === 0) {
            this.logger.error('Http', error, context);
          } else if (error.status >= 400) {
            this.logger.warn('Http', `status=${error.status} url=${req.urlWithParams}`, context);
          }
        }

        return throwError(() => error);
      }),
    );
  }

  private isFrontendLogRequest(url: string): boolean {
    const endpoint = environment.criticalLogEndpoint || '/frontend-logs';
    return url.includes(endpoint);
  }

  private isApiRequest(url: string): boolean {
    return isOurApiUrl(url);
  }
}
